import { createAction } from '@wix/communities-blog-client-common';
import { type CommonThunkAction } from '@app/types/common-thunk-action.type';

export const SET_APP_SETTINGS = 'appSettings/SET_APP_SETTINGS';
export const setAppSettingsAction = createAction(SET_APP_SETTINGS);

export const setAppSettings =
  (payload: any): CommonThunkAction<void> =>
  (dispatch) => {
    dispatch(setAppSettingsAction(payload));
    return Promise.resolve();
  };
